// extracted by mini-css-extract-plugin
export default {"popover":"PopoverSharedStyle_popover__MO8TS","active":"PopoverSharedStyle_active__Skvxf","backdrop":"PopoverSharedStyle_backdrop__4Ts36"};